import moment from 'moment';
import { orderBy, groupBy } from 'lodash';
import { SEARCH_DATE_FORMAT } from 'common/constants/constants';

export const getAreaPointRange = point => {
  const category = point?.category;
  if (!category) {
    return {};
  }

  const { after, before } = category;
  const from = moment(after).startOf('day').valueOf();
  const to = moment(before).endOf('day').valueOf();

  return {
    from,
    to
  };
};

export const getTickPositions = (searchRange, data) => {
  if (!searchRange.length) {
    return [];
  }

  const dataWithDate = data.map(item => {
    return { ...item, date: moment(item.time).format(SEARCH_DATE_FORMAT) };
  });
  const dataWithDateOrdered = orderBy(dataWithDate, 'date');
  const dataWithDateGrouped = groupBy(dataWithDateOrdered, 'date');
  const mapOfValueOfDates = Object.entries(dataWithDateGrouped).map(
    ([key, value]) => moment(value[0].time).valueOf()
  );
  const firstDate = mapOfValueOfDates[0];
  const lastDate = mapOfValueOfDates[mapOfValueOfDates.length - 1];

  if (searchRange.length === 1) {
    return [firstDate];
  }

  if (searchRange.length === 2) {
    return [firstDate, lastDate];
  }

  return [];
};
